import { render, staticRenderFns } from "./MultiSelectGlossary.vue?vue&type=template&id=fbdef5d2&"
import script from "./MultiSelectGlossary.vue?vue&type=script&lang=js&"
export * from "./MultiSelectGlossary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports